export default __webpack_public_path__ + "static/media/android-native.61df79f6.png";